const Solicitations = {
  path: '/solicitations',
  component: () => import('@/views/pages/Solicitations/SolicitationsRoute.vue'),
  meta: { layout: 'content' },
  children: [
    {
      path: 'marketing/home',
      name: 'solicitations-marketing-home',
      component: () => import('@/views/pages/Solicitations/Marketing/Solicitations/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'marketing/panel',
      name: 'solicitations-marketing-panel',
      component: () => import('@/views/pages/Solicitations/Marketing/SolicitationsPanel/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'marketing/tools',
      name: 'solicitations-marketing-tools',
      component: () => import('@/views/pages/Solicitations/Marketing/SolicitationsTools/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'marketing/report',
      name: 'solicitations-marketing-report',
      component: () => import('@/views/pages/Solicitations/Marketing/SolicitationsReport/home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'transport/home',
      name: 'solicitations-transport-home',
      component: () => import('@/views/pages/Solicitations/Transport/Solicitations/Home.vue'),
      meta: {
        layout: 'content',
      },
    },
  ],
}

export default Solicitations
